import { type BasePerformanceRequestFilterParams } from "features/Library/Common/models";
import { sendExportRequest } from "features/Library/Common/utils/performanceUtils";
import DataService from "../../services/eventsDataService";

export const doExport = (eventId: number, filterParams: BasePerformanceRequestFilterParams, eventTitle: string) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => DataService.getExport(eventId, filterParams),
    eventTitle,
    abortController,
  );
};

export const doDrilldownExport = (
  eventId: number,
  sessionId: string,
  sessionStart: string,
  filterParams: BasePerformanceRequestFilterParams,
  eventTitle: string,
) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => DataService.getDrilldownExport(eventId, sessionId, sessionStart, filterParams),
    eventTitle,
    abortController,
  );
};
